var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('Background'),_c('div',{staticClass:"link-container container-fluid"},[_c('LinkTable'),_c('ServerInfo',{staticClass:"server-info"}),_c('LicenceFooter')],1),_c('Logo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }